module.exports = __webpack_public_path__ + "static/media/gallery9.7bf418ba.jpg";